import React from 'react';

import { mosaiqStyled } from '../../lib';

import { RadioButtonProps } from './types';

import { RadioButtonContainer } from './RadioButton.styles';
import { Button } from '../Button';

const RadioButton = mosaiqStyled<RadioButtonProps, HTMLLabelElement>(
  ({
    disabled = false,
    onChange,
    label,
    labelProps,
    innerRef,
    inputProps,
    checked,
    id,
    ...props
  }) => {
    return (
      <RadioButtonContainer hasLabel={false} ref={innerRef} htmlFor={id} {...props}>
        <input
          type="radio"
          disabled={disabled}
          id={id ?? label}
          onChange={onChange}
          defaultChecked={checked}
          {...inputProps}
        />
        <Button variant="outline" forwardedAs="span" {...labelProps}>
          {label}
        </Button>
      </RadioButtonContainer>
    );
  },
);

RadioButton.displayName = 'RadioButton';

export default RadioButton;
